import { stringify } from 'qs';

export const multiSelectStringifyOptions = {
  format: 'RFC1738',
  addQueryPrefix: true,
  arrayFormat: 'brackets',
  sort: (a, b) => (a.localeCompare(b)),
};

export const normalizeToArray = (value) => {
  if (!value || value === '') return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') {
    return value.split(',').map((item) => item.trim()).filter(Boolean);
  }
  return [value];
};

export const isEmptySelection = (value) => {
  if (!value) return true;
  if (Array.isArray(value)) return value.length === 0;
  return String(value).trim() === '';
};

export const stringifyWithArrays = (params) =>
  stringify(params, multiSelectStringifyOptions);
